import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["hm0_output"];

  connect() {
    console.log("documents-signes JS en cours ...");
    super.connect();

    if (
      $("#partial-documents_signataires-content").length &&
      $("#partial-documents_signataires-content").text().search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.documents_signataires_hm_ajax(), 300);
    }

    if ($("#search").length && $("#quick_sort").length) {
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });

      this.handleSidebarScroll("documents_signe_");
      this.handleSidebarScroll("documents_signe_");
    }
  }

  documents_signataires_hm_ajax() {
    if (this.current_app && this.documents_signe_id) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/documents_signes/show_ajax_for_hm_documents_signataires?documents_signe_id=" +
        this.documents_signe_id +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-documents_signataires-content").html("");
          $("#partial-documents_signataires-content").html(text);
        })
      );
    }
  }

  get current_app() {
    return this.data.get("app");
  }

  get params() {
    return this.data.get("params");
  }

  get documents_signe_id() {
    return this.data.get("documents_signeid");
  }

  get url_solution() {
    return this.data.get("urlsolution");
  }
}
